"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roleLabels = void 0;
exports.roleLabels = [{ name: 'Admin', label: 'Admin' }];
//# sourceMappingURL=User.js.map